import axios from "axios";

let authToken = null;

export const setAxiosToken = (token) => {
    authToken = token;
};

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use((config) => {
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
});

export default apiClient;